export default __webpack_public_path__ + "static/media/delete-user.cb0561a5.svg";